










import { Vue, Component } from "vue-property-decorator";
import PromptCancellation from "@/modules/home/pages/PromptCancellation.vue";

import { namespace } from "vuex-class";

const Theme = namespace("theme");
@Component({
  metaInfo() {
    return {
      title: "Orba One",
    };
  },
  components: {
    "prompt-cancellation": PromptCancellation,
  },
})
export default class App extends Vue {
  @Theme.Action("fetchTheme") fetchTheme;
  @Theme.Action("setDefaultTheme") setDefaultTheme;
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    if (publicKey) {
      this.fetchTheme(publicKey)
        .then()
        .catch(() => {
          console.error(
            "Error! No public key found, verification process may fail."
          );
          this.setDefaultTheme();
        });
    } else {
      this.setDefaultTheme();
    }
  }
}
